export default "__VITE_ASSET__facdd8c2__"